import React, { memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import "../../components/pdf/Fonts.js"
import styles from "../../components/pdf/Styles.js"

const OrderedAnimalsPdf = ({
    orderedAnimals,
}) => {
    return (
        <>
            <PDFViewer style={{ width: '99%', height: '100vh' }}>
                <Document>
                    <Page size='A4' orientation='landscape' style={styles.page} wrap>
                        <View style={styles.topColumn} fixed>
                            <View style={styles.headers_container}>
                                <Text style={styles.headers}>{'Κωδικός Ζώου'}</Text>
                                <Text style={styles.headers}>{'Αριθμός Παραγγελίας'}</Text>
                                <Text style={styles.headers}>{'Αγοραστής'}</Text>
                                <Text style={styles.headers}>{'Πωλητής'}</Text>
                                <Text style={styles.headers}>{'Ημ/νία Παραγγελίας'}</Text>
                                <Text style={styles.headers}>{'Ημ/νία Αποστολής'}</Text>
                            </View>
                        </View>
                        <View style={styles.bottomColumns}>
                            {orderedAnimals.map((item, index) =>
                                <View key={index} style={styles.cells_container} wrap={false}>
                                    <Text style={styles.cell}>{item?.code}</Text>
                                    <Text style={styles.cell}>{item?.orderNumber}</Text>
                                    <Text style={styles.cell}>{item?.buyer}</Text>
                                    <Text style={styles.cell}>{item?.seller}</Text>
                                    <Text style={styles.cell}>{item?.orderDate ? new Date(item?.orderDate).toLocaleDateString("el-GR") : ""}</Text>
                                    <Text style={styles.cell}>{item?.executionDate ? new Date(item?.executionDate).toLocaleDateString("el-GR") : ""}</Text>
                                </View>
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(OrderedAnimalsPdf);
